<template>
	<div @click="onClick">
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Does not emit click event if set to true',
		},

		link: {
			type: String,
			required: false,
			default: null,
		},

		target: {
			type: String,
			required: false,
			default: '_self',
		},
	},

	methods: {
		onClick() {
			if (!this.disabled) {
				this.$emit('click');
			}
		},
	},
};
</script>
